module.exports = __webpack_public_path__ + "img/lf1.f54598e7.png";